"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5226],{

/***/ 45226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var themeOptions = {
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: "#005152"
        },
        secondary: {
            // light: will be calculated from palette.secondary.main,
            main: "#277680"
        },
        error: {
            // light: will be calculated from palette.error.main,
            main: "#dc3545"
        }
    },
    typography: {
        fontFamily: [
            '"Calibri"',
            '"Open Sans"',
            '"Helvetica"',
            '"Arial"'
        ].join(",")
    }
};
/* harmony default export */ __webpack_exports__["default"] = (themeOptions);


/***/ })

}]);